import { connect } from "react-redux"

import { selectCurrentEnvironment } from "redux/reducers/entities/companies"
import { createSelectCompanyByEnvironmentAction as selectCompany } from "redux/reducers/entities/companies/actions"

import {
    selectActiveName,
    selectIsReady,
    selectIsSubdomain,
    selectLoadingError,
} from "redux/reducers/core/environment"
import { createSelectLoadEnvironmentAction as selectEnvironment } from "redux/reducers/core/environment/actions"

import {
    selectHasActiveRoles,
    selectHasFetchedUser,
} from "redux/reducers/entities/users"
import { selectHasUserInvites } from "redux/reducers/entities/userInvites"

const mapStateToProps = state => ({
    isReady: selectIsReady(state),
    environmentName: selectActiveName(state),
    hasFetchedUser: selectHasFetchedUser(state),
    companyEnvironment: selectCurrentEnvironment(state),
    isSubdomain: selectIsSubdomain(state),
    hasEnvironmentError: !!selectLoadingError(state),
    hasActiveRoles: selectHasActiveRoles(state),
    hasInvites: selectHasUserInvites(state),
})

const mapDispatchToProps = {
    selectEnvironment,
    selectCompany,
}

export default connect(mapStateToProps, mapDispatchToProps)
